import { ListPage } from '@components/molecules';
import { TextFieldElement } from 'react-hook-form-mui';
import API from '@apps/nnc/services/machine';
import { ModelProps } from '@/types';
import { MachineSchema } from '@apps/nnc/schemas/machine';
import { GridColDef } from '@mui/x-data-grid';
import { JSX } from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SearchSchema } from '@/defaultschemas/search';
import AsyncAutocompleteElement from '@/components/atoms/asyncautocomplete';
import UnitAPI from '@apps/localization/services/unit';
import { YesNoAutocompleteElement } from '@/components/atoms';

export default function ObjectListPage(modelProps: ModelProps): JSX.Element {
  const { t } = useTranslation();
  const columns: GridColDef[] = [
    {
      field: 'name',
      headerName: t('Name'),
      flex: 1,
    },
    {
      field: 'unit',
      headerName: t('Unit'),
      flex: 1,
      renderCell: (params) => {
        return params.row.unit ? params.row.unit.label : '';
      },
    },
    {
      field: 'division_name',
      headerName: t('Identified Area'),
      flex: 1,
    },
    {
      field: 'production_phase',
      headerName: t('Production Phase'),
      flex: 1,
      renderCell: (params) => {
        return params.row.production_phase
          ? params.row.production_phase.label
          : '';
      },
      sortable: false,
    },
    {
      field: 'is_active',
      headerName: t('Is Active?'),
      type: 'boolean',
      sortable: false,
    },
  ];

  return (
    <ListPage
      schema={MachineSchema}
      schemaSearch={SearchSchema}
      title={t('Machine')}
      api={API}
      columns={columns}
      modelProps={modelProps}
      initialState={{
        sorting: {
          sortModel: [{ field: 'name', sort: 'asc' }],
        },
      }}
      customPath="nnc/machine"
    >
      <Grid size={{ xs: 12, md: 3 }}>
        <TextFieldElement name="search" label={t('Search')} fullWidth />
      </Grid>
      <Grid size={{ xs: 12, md: 3 }}>
        <AsyncAutocompleteElement
          name="unit"
          label={t('Unit')}
          api={UnitAPI.select}
          required
        />
      </Grid>
      <Grid size={{ xs: 12, md: 2 }}>
        <YesNoAutocompleteElement name="is_active" label={t('Is Active?')} />
      </Grid>
    </ListPage>
  );
}
